export default __webpack_public_path__ + "static/media/ImageSectionImageLeft.df2db032.svg";